import { DateFormats } from 'UI/constants/defaults';
import { currencyFormatter, formatPhoneNumber, toLocalTime } from 'UI/utils';

export const LogType = Object.freeze({
  Currency: 'currency',
  Date: 'date',
  DateList: 'dateList',
  Html: 'html',
  Percentage: 'percentage',
  Phone: 'phone',
  Text: 'text'
});

export const Operations = Object.freeze({
  Update: 'update'
});

export const formatText = {
  dateWithoutHours: value => toLocalTime(value).format(DateFormats.SimpleDate),
  date: value => toLocalTime(value).format(DateFormats.SimpleDateTime),
  percentage: value => `${value}%`,
  currency: value => currencyFormatter(value, 2),
  phone: value => (value && value.trim() !== '' ? formatPhoneNumber(value) : ''),
  text: value => value
};
